import { Box, Link } from '@mui/material'
import { MediaImageRender } from 'src/components/media-input/media-image-render.component'
import { IMedia } from 'src/types'

import { useStyles } from './styles'
import { SPACES } from 'src/constants'

interface IProps {
  media: IMedia[]
}

export const MediaList = ({ media }: IProps) => {
  const classes = useStyles()

  if (media?.length === 0) {
    return <>-</>
  }

  return (
    <ul className={classes.mediaList}>
      {media?.map((image) => (
        <li key={image.id}>
          <Box sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}>
            <MediaImageRender
              type={image.type}
              link={image.link_medium || image.link}
              modalLink={image.link}
              alt={image.title}
              className={classes.image}
            />
          </Box>
          <Box
            // className={classes.link}
            // target={'_blank'}
            // href={image.link}
            sx={{
              display: 'flex',
              gap: SPACES.xxxs,
              justifyContent: 'center',
              alignItems: 'center',

              wordBreak: 'break-all',
              maxWidth: 160,
            }}
          >
            {image.title}
            {/* <LinkIcon className={classes.linkIcon} /> */}
          </Box>
        </li>
      ))}
    </ul>
  )
}
